(function () {
  var DEPOSIT_VARIANT_ID = 44088507072646;
  var DEPOSIT_PRODUCT_ID = 7635967541382;
  var DEPOSIT_LINE_PROPERTY = '_bcgiftManagedDeposit';
  var DEPOSIT_UNITS_PROPERTY = '_bcgiftDepositUnits';
  var syncInFlight = false;
  var queuedSync = null;
  var checkoutSubmitting = false;

  function normalizeInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return isFinite(parsed) ? parsed : fallback;
  }

  function getProperty(item, key) {
    if (!item || !item.properties) return null;
    return item.properties[key];
  }

  function isManagedDepositLine(item) {
    return item && (item.product_id === DEPOSIT_PRODUCT_ID || getProperty(item, DEPOSIT_LINE_PROPERTY) === 'true');
  }

  function stringIncludes(value, needle) {
    return String(value || '').toLowerCase().indexOf(needle) !== -1;
  }

  function inferAlcoholEligibility(item) {
    if (!item) return false;
    if (item.product_id === DEPOSIT_PRODUCT_ID) return false;

    var alcoholKeywords = ['whisky', 'whiskey', 'wine', 'vodka', 'rum', 'tequila', 'shochu', 'sake', 'beer', 'islay', 'spirit', 'champagne', 'icewine'];
    var fields = [item.handle, item.product_type, item.title, item.variant_title];

    return alcoholKeywords.some(function (keyword) {
      return fields.some(function (field) {
        return stringIncludes(field, keyword);
      });
    });
  }

  function isEligibleSourceLine(item) {
    return getProperty(item, '_bcgiftDepositEligible') === 'true' || inferAlcoholEligibility(item);
  }

  function inferVariantPackUnits(item) {
    var variantTitle = String(item && item.variant_title || '').toLowerCase().trim();
    var match;
    var inferredUnits;

    if (!variantTitle) return 0;
    if (variantTitle === 'single bottle' || variantTitle === 'single can') return 1;

    match = variantTitle.match(/(?:^|[^0-9])(\d+)\s*(?:bottles?|cans?)(?:$|[^a-z])/);
    if (!match) match = variantTitle.match(/case\s+of\s+(\d+)/);
    if (!match) match = variantTitle.match(/(?:^|[^0-9])(\d+)\s*(?:-|\s)?pack(?:$|[^a-z])/);
    if (!match) return 0;

    inferredUnits = normalizeInt(match[1], 0);
    return inferredUnits > 0 ? inferredUnits : 0;
  }

  function getDepositUnitsForLine(item) {
    var variantPackUnits = inferVariantPackUnits(item);
    var propertyUnits = normalizeInt(getProperty(item, DEPOSIT_UNITS_PROPERTY), 0);
    var unitsPerSellableUnit = variantPackUnits > 0 ? variantPackUnits : propertyUnits;
    if (unitsPerSellableUnit <= 0 && inferAlcoholEligibility(item)) {
      unitsPerSellableUnit = 1;
    }
    if (unitsPerSellableUnit <= 0) return 0;
    return unitsPerSellableUnit * normalizeInt(item.quantity, 0);
  }

  function fetchJson(url, options) {
    return fetch(url, options || {}).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok) {
          var error = new Error('Request failed with status ' + response.status);
          error.response = response;
          error.payload = payload;
          throw error;
        }
        return payload;
      });
    });
  }

  function fetchCart() {
    return fetchJson('/cart.js', {
      headers: { Accept: 'application/json' }
    }).then(function (cart) {
      var items = (cart.items || []).map(function (item, index) {
        item.line = index + 1;
        return item;
      });
      cart.items = items;
      return cart;
    });
  }

  function buildPlan(cart) {
    var items = cart.items || [];
    var sourceLines = [];
    var managedDepositLines = [];
    var i;

    for (i = 0; i < items.length; i += 1) {
      if (isManagedDepositLine(items[i])) {
        managedDepositLines.push(items[i]);
      } else if (isEligibleSourceLine(items[i])) {
        sourceLines.push(items[i]);
      }
    }

    var requiredQuantity = sourceLines.reduce(function (sum, item) {
      return sum + getDepositUnitsForLine(item);
    }, 0);

    return {
      requiredQuantity: requiredQuantity,
      managedDepositLines: managedDepositLines
    };
  }

  function addDepositLine(quantity) {
    return fetchJson('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: DEPOSIT_VARIANT_ID,
            quantity: quantity,
            properties: {
              _bcgiftManagedDeposit: 'true'
            }
          }
        ]
      })
    });
  }

  function changeLine(line, quantity) {
    return fetchJson('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ line: line, quantity: quantity })
    });
  }

  function reconcileCart(plan) {
    var lines = plan.managedDepositLines;
    var primaryLine = lines[0];
    var mutated = false;
    var sequence = Promise.resolve();

    if (plan.requiredQuantity <= 0) {
      lines.forEach(function (line) {
        mutated = true;
        sequence = sequence.then(function () {
          return changeLine(line.line, 0);
        });
      });
      return sequence.then(function () {
        return mutated;
      });
    }

    if (!primaryLine) {
      mutated = true;
      return addDepositLine(plan.requiredQuantity).then(function () {
        return mutated;
      });
    }

    if (normalizeInt(primaryLine.quantity, 0) !== plan.requiredQuantity) {
      mutated = true;
      sequence = sequence.then(function () {
        return changeLine(primaryLine.line, plan.requiredQuantity);
      });
    }

    lines.slice(1).forEach(function (extraLine) {
      mutated = true;
      sequence = sequence.then(function () {
        return changeLine(extraLine.line, 0);
      });
    });

    return sequence.then(function () {
      return mutated;
    });
  }

  function syncDepositLines(options) {
    options = options || {};
    if (syncInFlight) {
      if (!queuedSync) {
        queuedSync = new Promise(function (resolve) {
          setTimeout(function () {
            queuedSync = null;
            resolve(syncDepositLines(options));
          }, 350);
        });
      }
      return queuedSync;
    }

    syncInFlight = true;
    return fetchCart()
      .then(function (cart) {
        return reconcileCart(buildPlan(cart));
      })
      .then(function (mutated) {
        syncInFlight = false;
        if (mutated && options.reloadOnMutation) {
          window.location.reload();
        }
        return mutated;
      }, function (error) {
        syncInFlight = false;
        console.error('BCgift deposit sync failed', error);
        throw error;
      });
  }

  function isCheckoutElement(element) {
    if (!element) return false;
    if (element.matches && element.matches('button[name="checkout"], input[name="checkout"], [data-bcgift-checkout], a[href*="/checkout"]')) return true;
    return false;
  }

  function findCheckoutTrigger(target) {
    var element = target;
    while (element && element !== document) {
      if (isCheckoutElement(element)) return element;
      element = element.parentNode;
    }
    return null;
  }

  function setCheckoutBusy(isBusy) {
    var controls = document.querySelectorAll('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    Array.prototype.forEach.call(controls, function (control) {
      if ('disabled' in control) control.disabled = isBusy;
      if (isBusy) {
        control.setAttribute('aria-busy', 'true');
      } else {
        control.removeAttribute('aria-busy');
      }
    });
  }

  function submitCheckoutForm(form) {
    if (!form) return;
    var hidden = form.querySelector('input[type="hidden"][name="checkout"]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'checkout';
      hidden.value = 'Checkout';
      form.appendChild(hidden);
    }
    checkoutSubmitting = true;
    if (typeof form.submit === 'function') {
      form.submit();
    } else {
      window.location.href = '/checkout';
    }
  }

  function forceSyncThenCheckout(trigger, event) {
    if (checkoutSubmitting) return;
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();
    setCheckoutBusy(true);

    syncDepositLines({ reloadOnMutation: false }).then(function () {
      var href = trigger.getAttribute && trigger.getAttribute('href');
      if (href && href.indexOf('/checkout') !== -1) {
        checkoutSubmitting = true;
        window.location.href = href;
        return;
      }
      submitCheckoutForm(trigger.form || trigger.closest && trigger.closest('form'));
    }, function () {
      setCheckoutBusy(false);
      alert('Deposit is still syncing. Please try checkout again in a moment.');
    });
  }

  window.BCgiftDepositSync = {
    sync: syncDepositLines,
    variantId: DEPOSIT_VARIANT_ID,
    productId: DEPOSIT_PRODUCT_ID
  };

  window.addEventListener('load', function () {
    syncDepositLines({ reloadOnMutation: true }).catch(function () {});
  });
  document.addEventListener('cart:update', function () {
    setTimeout(function () { syncDepositLines({ reloadOnMutation: true }).catch(function () {}); }, 250);
  });
  document.addEventListener('product:added', function () {
    setTimeout(function () { syncDepositLines({ reloadOnMutation: true }).catch(function () {}); }, 250);
  });
  document.addEventListener('click', function (event) {
    var trigger = findCheckoutTrigger(event.target);
    if (trigger) forceSyncThenCheckout(trigger, event);
  }, true);
  document.addEventListener('submit', function (event) {
    if (checkoutSubmitting) return;
    var submitter = event.submitter;
    if (submitter && isCheckoutElement(submitter)) {
      forceSyncThenCheckout(submitter, event);
    }
  }, true);
})();
